import { clientErrorTracker } from '@spotahome/soyuz/client';

import { getHomecardsQuery } from '../graphql/queries/homecards';
import getGqlClient from '../graphql/client';

function indexCardsById(cards) {
  return cards
    .filter(card => card)
    .reduce(
      (acc, card) => ({
        ...acc,
        [card.id]: {
          ...card
        }
      }),
      {}
    );
}

export const getCardsFromIds = async (cardIds, locale, context = {}) => {
  let newCards = {};
  if (cardIds.length) {
    try {
      const parsedCardIds = cardIds.map(id => parseInt(id, 10));

      const res = await getHomecardsQuery(getGqlClient())(
        parsedCardIds,
        locale,
        context
      );

      if (res.data) {
        newCards = indexCardsById(res.data.homecards);
      }
    } catch (err) {
      if (err?.cause?.name !== 'AbortError') {
        clientErrorTracker.error({ error: err, source: 'HomecardList' });
      }
    }
  }

  return newCards;
};

export default {
  getCardsFromIds
};
